// extracted by mini-css-extract-plugin
module.exports = {"portal":"Tooltip_portal__1GH1G","content":"Tooltip_content__LBlnl"};